/*
 * File: 客户经理看板-收入预测-版本管理
 */
<template>
    <div class="revenue-version">
        <Paper class="revenue-version-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        @search-change="versionList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        v-has="authorityCode.add"
                        type="primary"
                        size="mini"
                        title="新增"
                        icon="el-icon-plus"
                        @click="handleAdd">新增
                    </lotsButton>
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="刷新"
                        @click="versionList.getList()"
                        plain>
                        <span class="icon iconfont icon-refresh"></span>
                    </lotsButton>
                    <!-- <el-tooltip effect="dark" content="列配置" placement="bottom">
                        <el-button icon="iconfont icon-list_install" type="primary" size="mini" @click="handleColumnConfig" plain />
                    </el-tooltip> -->
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <edit-table-box
                        ref="editTableBox"
                        v-loading="versionList.tableLoading"
                        :key="rendertable"
                        :index="config.index"
                        :selection="config.selection"
                        :columns="config.columns"
                        :height="tableHeight"
                        :tableData="versionList.totalData"
                        :actions="config.actions || []"
                        :rowEdit="config.rowEdit"
                        :allowRowClick="false"
                        :allowRowClickFunc="config.rowDbClickFun"
                        :editDisableRule="config.disableEditFun"
                        @row-db-click="handleLink"
                        @btn-event="handleActive"
                    >
                        <template #col-header="{ item }">
                            {{ item.label }}
                            <el-tooltip v-if="item.tooltip" :content="item.tooltip" placement="top">
                                <i style="color: #5cb6ff; font-size: 14px" class="el-icon-info" />
                            </el-tooltip>
                        </template>
                        <template #col-append="{item, row}">
                            <!-- 预测版本 -->
                            <span
                                v-if="item.prop === 'forecastVersionCode'"
                                size="mini"
                                type="text"
                                :class="![0, 1].includes(+row.versionStatus) ? 'revenue-version-link' : ''"
                                @click="handleLink(row)"
                            >{{ row.forecastVersionCode }}</span>
                            <!-- 状态、待办推送状态 -->
                            <span v-else-if="['versionStatus', 'todoSendStatus'].includes(item.prop)">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey]) }}</span>
                            <span v-else>{{ row[item.prop] }}</span>
                        </template>
                        <template #edit-col-append="{ item, row }">
                            <!-- 预测版本 -->
                            <span v-if="item.prop === 'forecastVersionCode'">{{ row.forecastVersionCode }}</span>
                            <!-- 状态、待办推送状态 -->
                            <span v-if="['versionStatus', 'todoSendStatus'].includes(item.prop)">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey])}}</span>
                            <!-- 预测月份、滚动预测月数 -->
                            <div v-if="['periodMonth', 'rollMonths'].includes(item.prop)">
                                <div v-if="!row.todoSendStatus">
                                    <el-date-picker
                                        v-if="item.prop === 'periodMonth'"
                                        size="mini"
                                        v-model="row[item.prop]"
                                        type="month"
                                        format="yyyy-MM"
                                        value-format="yyyy-MM"
                                        placeholder="选择日期"
                                        @change="(val) => handleChangeRow({ prop: item.prop, val, row })"
                                    />
                                    <el-select v-if="item.prop === 'rollMonths'" v-model="row[item.prop]" :disabled="row.rollMonthsDisabled" @change="handleRendertable">
                                        <el-option
                                            v-for="it in rollMonthsOptions"
                                            :key="it.value"
                                            :label="it.label"
                                            :value="it.value"
                                        />
                                    </el-select>
                                </div>
                                <span v-else>{{ row[item.prop] }}</span>
                            </div>
                            <!-- 待办标题、待办内容、待办开始时间、待办结束时间 -->
                            <div v-if="['todoTitle', 'todoContent', 'todoStartTime', 'todoEndTime'].includes(item.prop)">
                                <div v-if="row.todoSendStatus">
                                    <el-input v-if="['todoTitle', 'todoContent'].includes(item.prop)" v-model="row[item.prop]" placeholder="请输入" size='mini' />
                                    <el-date-picker
                                        v-else
                                        size="mini"
                                        v-model="row[item.prop]"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期"
                                    />
                                </div>
                                <span v-else>{{ row[item.prop] }}</span>
                            </div>
                        </template>
                    </edit-table-box>

                    <!-- 表格列配置弹框 -->
                    <!-- <column-config
                        ref="columnConfigRef"
                        :pageID="config.name"
                        :initColumns="config.columns"
                        @header-change="config.columns = $event"
                    /> -->
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="versionList.sizeChange"
                        :current-page.sync="versionList.pageNo"
                        @current-change="versionList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="versionList.pageTotal"
                    />
                </template>
            </list-layout-paper>
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, onMounted, onActivated, getCurrentInstance } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import utils from '@/components/utils/common.js';
import store from '@/store';
import _ from 'lodash';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import { formatDictCodeToName } from '@/modules/mdm/utils.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
// import columnConfig from '@/components/lots/columnConfig/Index';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import {
    getRevenueVersionPage,
    getRevenueVersionByMonth,
    revenueVersionAdd,
    revenueVersionUpdate,
    revenueVersionSubmit,
    revenueVersionSend,
    revenueVersionResend
} from '@mdm/api/customer/revenueVersion.js';
import { config as configStatic } from './config';

export default {
    name: 'revenueVersion',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        lotsButton,
        editTableBox,
        lotsPagination
        // columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.revenueVersion);
        const { user } = store.getters;
        const ctx = getCurrentInstance();
        const config = reactive(configStatic);
        const dictDatas = ref({});
        const rollMonthsOptions = ref([]);
        const rendertable = ref(1);

        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        return {
                            edit: -3,
                            allowEdit: true,
                            ...v,
                            versionStatus: v.versionStatus?.toString()
                        }; ;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }
        const versionList = new AccountListClass({
            Api: {
                listApi: getRevenueVersionPage // 查询接口
            }
        });
        // 查询参数转换
        const searchDataFormat = (condition = {}, params = {}) => {
            if (condition.createTimeFixed) {
                condition.createTimeStart = utils.formatDateTime(condition.createTimeFixed[0]);
                condition.createTimeEnd = utils.formatDateTime(condition.createTimeFixed[1]);
                Reflect.deleteProperty(condition, 'createTimeFixed');
            }

            const newParams = { ...condition, ...params, userCode: user.userCode };
            Object.keys(newParams).forEach(v => {
                if (newParams[v] === undefined || newParams[v] === null || newParams[v] === '') {
                    delete newParams[v];
                }
            });
            return newParams;
        };
        // 刷新表格
        const handleRendertable = () => {
            rendertable.value++;
        };
        // 跳转到收入预测页面
        const handleLink = (row) => {
            // 状态≠草稿/跑数中，可跳转
            if ([0, 1].includes(+row.versionStatus)) return;
            ctx.$router.push({ path: '/mod/mdm/revenue-forecast', query: { version: row.forecastVersionCode, periodMonth: row.periodMonth } });
        };
        // 新增
        const handleAdd = () => {
            versionList.totalData.value.unshift({
                edit: 2,
                allowEdit: true,
                versionStatus: '0', // 草稿
                rollMonthsDisabled: false
            });
            const timer = setTimeout(() => { // 解决表格错位
                setupContext.refs.editTableBox.$refs.moduleTable.doLayout();
            });
            timer && clearTimeout(timer);
        };
        // 列配置
        // const handleColumnConfig = () => {
        //     setupContext.refs.columnConfigRef.show(true);
        // };
        // 表格内表单元素发生变化时回调
        const handleChangeRow = async ({ prop, val, row }) => {
            if (prop === 'periodMonth') {
                row.rollMonths = '';
                row.rollMonthsDisabled = false;
                if (val) {
                    // 当存在同预测年月的版本时，自动按V1版本的滚动预测月数带出并只读
                    const { data } = await getRevenueVersionByMonth({ periodMonth: val });
                    if (data && data.length) {
                        row.rollMonths = data.find((v) => v.forecastVersionCode === 'V1')?.rollMonths;
                        row.rollMonthsDisabled = true;
                    }
                }
                handleRendertable();
            }
        };
        // 操作项
        const handleActive = (row, event) => {
            // 取消
            if (event === 'cancel') {
                handleRendertable();
            }
            // 保存
            if (event === 'save') {
                handleSave(row);
            }
            // 审核
            if (event === 'verify') {
                handleVerify(row);
            }
            // 推送待办
            if (event === 'send') {
                handleSend(row);
            }
            // 重推待办
            if (event === 'resend') {
                handleResend(row);
            }
        };
        // 保存
        const handleSave = async (row) => {
            const valid = handleValid(row);
            if (!valid) return;
            const { code } = row.id ? await revenueVersionUpdate(row) : await revenueVersionAdd(row);
            if (+code === 0) {
                Message.success('保存成功');
                versionList.getList();
            }
        };
        // 审核
        const handleVerify = (row) => {
            MessageBox.confirm('审核后将触发生成版本，请确认！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const { code } = await revenueVersionSubmit(row);
                    if (+code === 0) {
                        Message.success('审核成功');
                        versionList.getList();
                    }
                });
        };
        // 推送待办
        const handleSend = async (row) => {
            const valid = handleValid(row);
            if (!valid) return;
            const todoSendStatus = await getTodoSendStatus(row);
            if (todoSendStatus === 'completed') {
                Message.warning('已推送，请勿重复操作');
                versionList.getList();
                return;
            }
            if (todoSendStatus !== 'draft') return;

            const { code } = await revenueVersionSend(row);
            if (+code === 0) {
                Message.success('开始推送');
                versionList.getList();
            }
        };
        // 重推待办
        const handleResend = async (row) => {
            const valid = handleValid(row);
            if (!valid) return;
            const todoSendStatus = await getTodoSendStatus(row);
            if (!['failed', 'completed'].includes(todoSendStatus)) return;

            MessageBox.confirm(todoSendStatus === 'completed' ? '已推送，请确认刷新待办信息？' : '请确认是否重推待办信息？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const { code } = await revenueVersionResend(row);
                    if (+code === 0) {
                        Message.success('开始推送');
                        versionList.getList();
                    }
                });
        };
        // 校验待办信息必填
        const handleValid = (row) => {
            const todoStartTime = utils.formatDateTimestamp(row.todoStartTime);
            const todoEndTime = utils.formatDateTimestamp(row.todoEndTime);
            const todoTitle = _.trim(row.todoTitle);
            const todoContent = _.trim(row.todoContent);
            if (row.todoSendStatus && (!todoTitle || !todoContent || !todoStartTime || !todoEndTime)) {
                Message.warning('请填写完整待办信息');
                return false;
            }
            if (todoStartTime && todoEndTime && todoStartTime > todoEndTime) {
                Message.warning('待办开始时间不能晚于待办结束时间');
                return false;
            }
            return true;
        };
        // 获取最新待办推送状态
        const getTodoSendStatus = async (row) => {
            const params = {
                pageNo: 1,
                pageSize: 10,
                userCode: user.userCode,
                forecastVersionCode: row.forecastVersionCode,
                periodMonth: row.periodMonth
            };
            const { data } = await getRevenueVersionPage(params);
            return data.list ? data.list[0].todoSendStatus : '';
        };

        onActivated(() => {
            setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
        });
        onMounted(async() => {
            setupContext.refs.searchBox.submitSearch();
            const { data } = await getDictDataApi({ dictCodes: 'CRM_FORECAST_VERSION_STATUS,CRM_TODO_SEND_STATUS' });
            dictDatas.value = data || {};

            // 设置滚动预测月数下拉项
            const number = 12;
            for (let i = 3; i <= number; i++) {
                rollMonthsOptions.value.push({ label: i, value: i });
            }
        });
        return {
            versionList,
            config,
            authorityCode,
            dictDatas,
            rollMonthsOptions,
            rendertable,
            formatDictCodeToName,
            handleRendertable,
            handleLink,
            handleAdd,
            // handleColumnConfig,
            handleChangeRow,
            handleActive
        };
    }
};
</script>

<style lang="less">
.revenue-version {
    width: 100%;
    .revenue-version-paper {
        height: 100%;
    }
    .header-button {
        margin-left: 10px;
    }
    .search-box .el-select .el-input input {
        height: 28px!important;
    }
    .list-layout-wrapper {
        height: 100%;
    }
    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.revenue-version-paper {
        padding: 0px 0px 0px;
    }
    .revenue-version-link {
        color: #4285f5;
        cursor: pointer;
    }
    .edit-table-box .el-select, .edit-table-box .el-date-editor {
        width: 100%;
        .el-input__inner {
            padding-right: 16px !important;
            padding-left: 22px !important;
        }
        .el-input__prefix {
            left: 0 !important;
        }
    }
}
</style>
